import React from 'react';
import { Builder } from 'lunr';
import './App.css';

function SearchPane(props) {
  const [getStatus, setStatus] = React.useState("");
  const [getSearchText, setSearchText] = React.useState("");
  const [getRefresh, setRefresh] = React.useState(0);

  const changeSearchText = (e) => {
    setSearchText(e.target.value);
  }

  const onKeyDown = (e) => {
    if (e.keyCode === 13) {
      var text = getSearchText;
      //var text = document.getElementById('searchterm').value;
      console.log("Search Text:", text);

      console.log("Building Index...");

      let builder = new Builder();
      builder.ref('id');
      builder.field('ActivityId');
      builder.field('ErrorCode');
      builder.field('ErrorCodeMsg');
      builder.field('ErrorType');
      builder.field('File');
      builder.field('Function');
      builder.field('Instance');
      builder.field('Level');
      builder.field('Line');
      builder.field('MDRESULT');
      builder.field('Message');
      builder.field('Pid');
      builder.field('Stream');
      builder.field('Tid');
      builder.field('TimeStamp');
      builder.field('traceparentId');
      builder.field('Date');
      builder.field('Time');

      for (let n in props.Records)
      {
        if (n === "meta") {
          continue;
        }
        let id = props.Records[n];
        let rec = props.Index.Records[id];
        builder.add(rec);
      }

      let idx = builder.build();

      // ***************

      let searchResults = [];

      try {
        let results = idx.search(text);
        setStatus("Found: " + results.length + ', "' + text + '"')
        
        for (let n in results)
        {
          searchResults.push(Number(results[n].ref));
        }

        props.UpdateSearchResults(text, searchResults);
      }
      catch(e) {
        console.log("Search Failed:", e);
        setStatus("Failed: " + e.message);
        props.UpdateSearchResults("", []);
      }
    }
  }

  if (props.Records.length !== getRefresh)
  {
    setRefresh(props.Records.length);
    setStatus("");
    setSearchText("");
  }

  var items = [];

  items.push(
    <span key={items.length}>
      Search:
      <span className="mr-1 ml-1">
        <input id='searchterm' type="text" size="16" value={getSearchText} onChange={changeSearchText} onKeyDown={onKeyDown}></input>
      </span>
      <span>{getStatus}</span>
    </span>
  );

  return (
    <span>
      {items}
    </span>
  );
}

export default SearchPane;
